import { Button, Checkbox, Modal } from "antd";
import styled from "styled-components";
import { COLORS, SIZES, WEIGHT } from "../../../../layout/theme";

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
	padding: 10px 0 30px 0;
`;

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 28px;
	font-weight: 800;
	line-height: 1.1;
	color: #111827;
`;

export const InnerForm = styled.div`
	display: grid;
	grid-template-columns: minmax(0, 1.65fr) minmax(320px, 0.9fr);
	gap: 22px;
	align-items: start;

	@media only screen and (max-width: 1100px) {
		grid-template-columns: 1fr;
	}
`;

export const ClientData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
`;

export const PublishSettings = styled.div`
	display: flex;
	flex-direction: column;
	gap: 22px;
`;

export const SectionData = styled.div`
	background-color: ${COLORS.White};
	padding: 22px 20px;
	border-radius: 16px;
	display: flex;
	flex-direction: column;
	gap: 18px;
	box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
	border: 1px solid #eceff3;
`;

export const PurpleSectionCard = styled.div`
	background-color: ${COLORS.White};
	border-radius: 16px;
	overflow: hidden;
	box-shadow: 0 4px 16px rgba(15, 23, 42, 0.08);
	border: 1px solid #eceff3;
`;

export const PurpleSectionHeader = styled.div`
	background: linear-gradient(
		90deg,
		${COLORS.Primary} 0%,
		${COLORS.Primary} 100%
	);
	color: white;
	padding: 14px 18px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
	font-size: 16px;
	font-weight: 800;
`;

export const PurpleSectionBody = styled.div`
	padding: 0px 18px;
`;

export const SectionHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 12px;
`;

export const SectionTitle = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	font-size: 16px;
	font-weight: 800;
	color: #4f46e5;
`;

export const SectionHint = styled.div`
	font-size: 14px;
	color: #64748b;
`;

export const DistributorImage = styled.img`
	width: 40px;
	height: 40px;
	object-fit: contain;
`;

export const PreviewImage = styled.img`
	width: 150px;
	height: 150px;
	object-fit: contain;
`;

export const Container = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 12px;
`;

export const KeyValue = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const KeyLabel = styled.div`
	font-size: 13px;
	font-weight: 700;
	color: #6b7280;
	text-transform: uppercase;
`;

export const KeyValueText = styled.div`
	font-size: 16px;
	font-weight: 700;
	color: #111827;
`;

export const AntdCheckbox = styled(Checkbox)`
	.ant-checkbox-inner {
		width: 18px;
		height: 18px;
		border-radius: 5px;
	}
`;

export const ModalText = styled.div`
	cursor: pointer;
	display: inline-flex;
	gap: 6px;
	justify-content: flex-start;
	align-items: center;
	color: ${(props) => (props.textColor === 1 ? "#4f46e5" : COLORS.Secondary)};
	font-size: ${SIZES.level6};
	font-weight: 700;
`;

export const AntdModal = styled(Modal)`
	.ant-modal-content {
		border-radius: 18px;
		overflow: hidden;
	}

	.ant-modal-header {
		border-bottom: 1px solid #eef2f7;
		padding: 18px 22px;
	}

	.ant-modal-body {
		background-color: ${COLORS.LightGrey};
		padding: 20px;
	}
`;

export const UncheckedOrderAlert = styled.span`
	color: ${COLORS.Danger};
	font-weight: ${WEIGHT.Bold};
	margin-left: 10px;
	font-size: 13px;
`;

export const PrimaryButton = styled(Button)`
	width: 100%;
	height: 52px;
	border-radius: 12px;
	border: none;
	background: linear-gradient(90deg, #4f46e5 0%, #4338ca 100%);
	color: white;
	font-size: 16px;
	font-weight: 800;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #3730a3 100%) !important;
		color: white !important;
		border: none !important;
	}
`;

export const SecondaryButton = styled(Button)`
	width: 100%;
	height: 48px;
	border-radius: 12px;
	border: none;
	background: #eef2ff;
	color: #4338ca;
	font-size: 15px;
	font-weight: 700;

	&:hover,
	&:focus,
	&:active {
		background: #e0e7ff !important;
		color: #3730a3 !important;
		border: none !important;
	}
`;

export const AntdButton = styled(Button)`
	${(props) => props.height && `height: ${props.height}px;`}
	${(props) => props.width && `width: ${props.width}px;`}
	${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}

	height: 48px;
	border-radius: 12px;
	border: none;
	background: linear-gradient(90deg, #3b82f6 0%, #2563eb 100%);
	color: ${COLORS.White};
	font-weight: ${WEIGHT.Bold};
	box-shadow: 0 8px 18px rgba(37, 99, 235, 0.18);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #2563eb 0%, #1d4ed8 100%) !important;
		color: ${COLORS.White} !important;
		border: none !important;
	}

	span {
		${(props) => props.height && `height: ${props.height}px;`}
		${(props) => props.fontSize && `font-size: ${props.fontSize}px;`}
	}
`;

export const CuitInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 4px 0 0 0;
`;

export const Section = styled.div`
	display: flex;
	gap: 10px;
	justify-content: space-between;
	align-items: flex-start;
	padding-bottom: 8px;
	border-bottom: 1px solid #f1f5f9;

	&:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}
`;

export const StatusSelectWrap = styled.div`
	.ant-select {
		width: 100%;
	}

	.ant-select-selector {
		height: 42px !important;
		border-radius: 10px !important;
		border: 1px solid #d1d5db !important;
		display: flex;
		align-items: center;
		padding: 0 12px !important;
	}
`;
